import { fromJS } from 'immutable';

/**
 * Since https://wiqlimited.atlassian.net/browse/PROD-3721 there is some overlap between allergens and
 * lifestyle choices, which were previously always separate concepts. Pork and alcohol are stored as allergens,
 * so that they can be filtered out from a menu, BUT we also want their icons to show next to the lifestyle
 * icons in the SuitableFor component, and to hide these when viewing a specific product's allergens.
 *
 * Therefore, allergensAsLifestyleChoices is the list of allergens for which the icon should be displayed in
 * SuitableFor. And allergensExcludingAsLifestyleChoices is the full list of allergens which is used in
 * displaying a product's allergen list.
 */
const filters = {
  allergens: [
    'celery',
    'crustaceans',
    'eggs',
    'fish',
    'gluten',
    'gluten_wheat',
    'gluten_rye',
    'gluten_barley',
    'gluten_oats',
    'lupin',
    'milk',
    'molluscs',
    'mustard',
    'nuts',
    'nut_almonds',
    'nut_hazelnuts',
    'nut_walnuts',
    'nut_cashews',
    'nut_pecan',
    'nut_brazil',
    'nut_pistachio',
    'nut_macadamia',
    'peanuts',
    'sesame_seeds',
    'soya',
    'sulphur_dioxide',
    'alcohol',
    'pork',
  ],
  lifestyleChoices: ['halal', 'kosher', 'vegetarian', 'vegan', 'gluten_free'],
  allergensAsLifestyleChoices: ['alcohol', 'pork'],
};
filters.allergensExcludingAsLifestyleChoices = filters.allergens.filter(
  allergen => !filters.allergensAsLifestyleChoices.includes(allergen)
);

export default fromJS(filters);
